/* eslint-disable react/jsx-no-bind */
import React from 'react';
import { Route, Redirect } from 'react-router-dom';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import ToastrService from '../../services/toastrService';
import * as browserCheck from '../../utils/browserCheck.js';

const PrivateRoute = ({ component: Component, authenticated: authenticated, location, requireProfile, activeProfile, ...rest }) => {
  return <Route
    {...rest}
    render={props =>
      authenticated === true ? 
        requireProfile && !activeProfile ?
          <Redirect to={{
            pathname: `/Profile/Create`,
            //search: `?returnUrl=${location.pathname}`,
            state: { from: location }
            }} />
          :
          <Component {...props} />
       : 
        <Redirect to={`/Account/Login?returnUrl=${location.pathname}`} />      
    }
  />;
};

PrivateRoute.propTypes = {
    authenticated: PropTypes.bool.isRequired,
    location: PropTypes.object.isRequired,
    requireProfile: PropTypes.bool,
    activeProfile: PropTypes.object,
    component: PropTypes.oneOfType([
      PropTypes.element,
      PropTypes.function
    ]),
};

const mapStateToProps = state => ({
    authenticated: state.account.user != null,
    activeProfile: state.account.user ? state.account.user.activeProfile : null
});

export default connect(mapStateToProps)(PrivateRoute);